import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import logo from './logo-full.svg';
import './JCBSmallLogo.css';
import { useIwaContext } from '@cognitranlimited/itis-web';
export var JCBSmallLogo = function () {
    var strings = useIwaContext().strings;
    return _jsx("img", { className: "JCBSmallLogo", src: logo, alt: strings.app.name });
};
